module.exports = __webpack_public_path__ + "347f4896e27c8289252d30bcf73cbd12.jpg";